exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexy {\n    font-family: sans-serif;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    overflow: auto;\n}\n\n.flexin {\n    -webkit-box-flex: 0;\n        -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'>];\n            flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'>];\n    max-width: 33%;\n    -ms-flex-preferred-size: 33%;\n        flex-basis: 33%;\n}\n\nimg {\n    margin: 0;\n    height: 200px;\n    width: 350px;\n    -o-object-fit: cover;\n       object-fit: cover;\n    overflow: hidden;\n    display: block;\n    background: #ccc;\n}\n\nfigure {\n    margin: 0;\n    overflow: hidden;\n}\n\nfigcaption {\n    text-align: center;\n    margin-top: 15px;\n}\n\n@media only screen and (max-width: 420px) {\n    figure img {\n        width: 100%;\n        height: 100%;\n        -o-object-fit: cover;\n           object-fit: cover;\n        overflow: hidden;\n        display: block;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/welcome/welcome-extras-bar/welcome-extras-bar.component.css
// module id = 378
// module chunks = 1